const en = {
    menu: {
        home: "Home",
        new_game: "New game",
        favorite_game: "Favorite game",
        slot: "Slot",
        live: "Live",
        live_casino: "Live Casino",
        promotions: "Promotions",
        contact_us: "Contact Us",
        supplier: "Supplier",
        all_providers: "All Providers",
        english: "English",
        japanese: "日本語"
    },

    common: {
        user_name: 'User Name',
        pass_word: 'Login Password',
        login: "Login",
        sign_out: "Sign Out",
        search_games: "Search for games",
        load_more: "Load more",
        loading: "Loading",
        loading_game: "Loading game...",
        level: "Level",
        balance: "Balance",
        play_now: "PLAY NOW",
        play_game: "PLAY GAME",
        game_name: "Game Name",
        play_for_real: "PLAY FOR REAL",
        user_name_place_holder: "Username is 6 to 16 bits",
        password_place_holder: "Enter your 6 to 16 digit login password",
        remember_password: "Remember password",
        logging_in: "Logging..."
    },

    game: {
        gems_bonanza: "GEMS BONAZA",
        game_demo: "GAME DEMO",
    },

    message: {
        invalid_credentials: "Invalid credentials",
        validation_failed: "Validation failed",
        no_games_found: "No Games Found",
        error_update_user: "Error updating user data:",
        error_fetch_balance: "Error fetching balance:",
    },
};

export default en;